import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { PharmacyDetails } from "@/api/interfaces";

export const getPharmacyApi = createApi({
  reducerPath: "pharmacyDetailReducer",
  baseQuery: fetchBaseQuery({ baseUrl: site.baseUrl }),
  endpoints: (builder) => ({
    getPharmacy: builder.query<PharmacyDetails, { provider_id: string }>({
      query: (payload) => {
        return {
          url: "/pharmacy/get",
          method: "POST",
          body: payload,
        };
      },
    }),
  }),
});

export const { useGetPharmacyQuery } = getPharmacyApi;
